import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import HeatMap from '../HeatMap'
import { TickerItem } from '@/types/current_activity'
import { useResizeDetector } from 'react-resize-detector'
import { DateTime } from 'luxon'
import { useAppState } from '@/contexts/StateContext'
import { TIMEZONE, TIMEZONE_VALUE } from '@/utils/constant'
import { useMemo } from 'react'

interface ActivityChartProps {
  data: TickerItem[]
}

const ActivityChart = ({ data }: ActivityChartProps) => {
  const { width, ref } = useResizeDetector()
  const { currentCohort } = useAppState()

  // Get the current date and time in the local time zone
  const now = DateTime.local().setZone(TIMEZONE[currentCohort.timezone])

  // Set the time to 7am today
  const startOfDay = now.startOf('day').set({ hour: 7 })

  // Set the time to 7pm today
  const endOfDay = now.startOf('day').set({ hour: 19 })

  const filteredData = useMemo(
    () =>
      data.filter((event) => {
        const activityTime = DateTime.fromFormat(event.activity_time, 'yyyy-MM-dd HH:mm:ss.SSS')
        const activityTimeInMinutes = activityTime.hour * 60 + activityTime.minute

        const startOfDayInMinutes = startOfDay.hour * 60 + startOfDay.minute
        const endOfDayInMinutes = endOfDay.hour * 60 + endOfDay.minute

        return (
          activityTimeInMinutes >= startOfDayInMinutes && activityTimeInMinutes <= endOfDayInMinutes
        )
      }),
    [data, startOfDay, endOfDay]
  )

  return (
    <Stack flex={1}>
      <Box
        borderBottom="1px solid rgba(255, 255, 255, 0.18)"
        display="flex"
        flex={1}
        alignItems="flex-end"
        ref={ref}
      >
        <HeatMap cWidth={width} size={4} spacing={1} nRow={18} nCol={144} data={filteredData} />
      </Box>
      <Stack direction="row" justifyContent="space-between" mt={2}>
        <Typography variant="caption" color="#90949A">
          7AM {TIMEZONE_VALUE[currentCohort.timezone]}
        </Typography>
        <Typography variant="caption" color="#90949A">
          7PM {TIMEZONE_VALUE[currentCohort.timezone]}
        </Typography>
      </Stack>
    </Stack>
  )
}

export default ActivityChart
